import { useState } from 'react';
import { useTranslation } from '@packages/utils';
import {
  useShowToastNotification,
  ENotificationType,
} from 'components/Base/Notification';
import { TRtkErrorType } from 'data/types/generic.types';
import { useDeleteEventRegistrantMutation } from 'redux/apiSlice/registrants.slice';

interface DeleteEventRegistrantParams {
  eventId: string;
  registrantId: string;
}

export const useDeleteEventRegistrant = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const { showToastNotification } = useShowToastNotification();
  const [deleteEventRegistrantMutation] = useDeleteEventRegistrantMutation();

  const deleteEventRegistrant = async ({
    eventId,
    registrantId,
  }: DeleteEventRegistrantParams) => {
    setIsLoading(true);

    try {
      await deleteEventRegistrantMutation({ eventId, registrantId }).unwrap();

      showToastNotification({
        message: t(
          'descriptions.admin-portal.events.details.event-registrants.actions.delete.modal.SUCCESS_MESSAGE',
        ),
        type: ENotificationType.SUCCESS,
      });

      return true;
    } catch (err) {
      console.error('Delete operation failed:', err);

      showToastNotification({
        message:
          (err as TRtkErrorType)?.data?.message ||
          t(
            'descriptions.admin-portal.events.details.event-registrants.actions.delete.modal.ERROR_MESSAGE',
          ),
        type: ENotificationType.ERROR,
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { deleteEventRegistrant, isLoading };
};
